import axios from "@/libs/api.request";
export const getList = params => {
  return axios.request({
    url: "/finance/DblFinanceRule",
    method: "GET",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/user/roleMapping/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/finance/DblFinanceRule/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/finance/DblFinanceRule/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/finance/DblFinanceRule",
    method: "POST",
    data
  });
};

export const getAccount = params =>{
  return axios.request({
    url:'/common/customer/finance',
    method:'GET',
    params
  })
}
